import React, { useEffect, useState } from "react";

const ORDER_TYPE_OPTIONS = [
  {
    id: "POST_ONLY",
    title: "Post Only",
    description:
      "The order will be filled as Maker only, or will be canceled if it is to be filled as Taker.",
  },
  {
    id: "FOK",
    title: "Fill or Kill (FOK)",
    description: "This order must be filled in full immediately, otherwise it will be canceled.",
  },
  {
    id: "IOC",
    title: "Immediate Or Cancel (IOC)",
    description:
      "The order will be filled as much as possible immediately, and any unfilled portion will be canceled.",
  },
];

export function advancedLimitOrderTypeLabel(id) {
  const hit = ORDER_TYPE_OPTIONS.find((o) => o.id === id);
  return hit?.title ?? "Post Only";
}

/**
 * Margin — Advanced Limit “Order Type” sheet (Post Only / FOK / IOC).
 * Styling: `margin.css` (`agce-margin-ordty-*`).
 */
export default function MarginAdvancedLimitOrderTypeModal({ open, onClose, orderType, onConfirm }) {
  const [draft, setDraft] = useState(orderType);

  useEffect(() => {
    if (open) setDraft(orderType);
  }, [open, orderType]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="agce-margin-ordty-modal-root" role="presentation">
      <div className="agce-margin-ordty-modal-backdrop" onClick={onClose} aria-hidden />
      <div
        className="agce-margin-ordty-modal-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="agce-margin-ordty-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="agce-margin-ordty-modal-head">
          <h2 id="agce-margin-ordty-title" className="agce-margin-ordty-modal-title">
            Order Type
          </h2>
          <button type="button" className="agce-margin-ordty-modal-close" onClick={onClose} aria-label="Close">
            <i className="ri-close-line ri-lg" aria-hidden />
          </button>
        </div>
        <div className="agce-margin-ordty-modal-body">
          {ORDER_TYPE_OPTIONS.map((o) => (
            <button
              key={o.id}
              type="button"
              className={`agce-margin-ordty-option${draft === o.id ? " is-selected" : ""}`}
              onClick={() => setDraft(o.id)}
              aria-pressed={draft === o.id}
            >
              <span className="agce-margin-ordty-option-title">{o.title}</span>
              <span className="agce-margin-ordty-option-desc">{o.description}</span>
            </button>
          ))}
        </div>
        <div className="agce-margin-ordty-modal-foot">
          <button
            type="button"
            className="agce-margin-ordty-btn-confirm"
            onClick={() => {
              onConfirm?.(draft);
              onClose?.();
            }}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}
